module.exports = ".content-page-not-found{\n    height: 100vh;\n}\n.content-page-not-found .titlePage img{\n    width: 100%;\n    max-width: 350px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/not-found/not-found.component.css
// module id = ./src/app/pages/not-found/not-found.component.css
// module chunks = main